import React from "react";
import styled from "styled-components";

import { color, fontFamily } from "style/constants";
import PulseHumpInverse from "assets/pulse_hump_inverse.svg";

export interface PulseHeaderProps {
  score: number;
}

const HeaderWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 18.6vh;
  margin-bottom: 5vh;
`;

const HumpImg = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: fill;
`;

const HeaderOverlay = styled.div`
  position: absolute;
  inset: 0;

  display: flex;
  flex-direction: column;
  align-items: center;

  padding: clamp(10px, 2vh, 20px) 0;
`;

const PageTitle = styled.h1`
  margin: 0 0 clamp(8px, 2vh, 16px) 0;

  text-align: center;
  font-family: ${fontFamily.secondary};
  font-weight: 400;
  font-size: clamp(1.125rem, 3vw, 1.75rem);
  line-height: 1.05;

  color: ${color.BLACK};
`;

const ScoreCircle = styled.div`
  margin-top: auto;
  margin-bottom: clamp(20px, 4vh, 40px);

  width: clamp(100px, 11vmin, 128px);
  aspect-ratio: 1;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  background: ${color.WHITE};
  border: 1.5px solid ${color.BLACK};

  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.15);
`;

interface ScoreNumberProps {
  charCount: number;
}

const ScoreNumber = styled.span<ScoreNumberProps>`
  font-family: ${fontFamily.primary};
  font-size: ${({ charCount }) =>
    charCount <= 3
      ? "clamp(1.25rem, 4.5vmin, 2.5rem)"
      : "clamp(1rem, 3.5vmin, 2rem)"};
  font-weight: 700;
  line-height: 1;

  color: ${color.DARKBLUE};
`;

const PulseHeader: React.FC<PulseHeaderProps> = ({ score }) => {
  const roundedScore = Math.round(score);
  const scoreText = String(roundedScore);

  return (
    <HeaderWrapper data-testid="pulse-header">
      <HumpImg src={PulseHumpInverse} alt="" aria-hidden />

      <HeaderOverlay>
        <PageTitle>My BrainHealth Pulse</PageTitle>

        <ScoreCircle data-testid="pulse-score-circle">
          <ScoreNumber
            charCount={scoreText.length}
            data-testid="pulse-score-value"
          >
            {roundedScore}
          </ScoreNumber>
        </ScoreCircle>
      </HeaderOverlay>
    </HeaderWrapper>
  );
};

export default PulseHeader;
